import axios from 'axios';
import { redirectToLogin, redirectToForbidden } from '../utils/common';

const UNAUTHORIZED = 401;
const FORBIDDEN = 403;

const baseConfiguration = {
  headers: {
    common: {
      'Access-Control-Allow-Credentials': true,
      'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate',
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
      'X-Content-Type-Options': 'nosniff',
      'X-Frame-Options': 'DENY',
    },
  },
  withCredentials: true,
  timeout: 30000,
};

const getClient = apiConfig => {
  const client = axios.create({ ...baseConfiguration, ...apiConfig });

  client.interceptors.response.use(
    config => config,
    error => {
      if (error && error.response.status === UNAUTHORIZED) {
        redirectToLogin();
      } else if (error && error.response.status === FORBIDDEN) {
        redirectToForbidden();
      }

      throw error;
    }
  );

  return client;
};

export default getClient;
